'use client';

import { useEffect, useState } from 'react';

const COLORS = [
  'var(--neon-cyan)',
  'var(--neon-green)',
  'var(--neon-yellow)',
  'var(--neon-magenta)',
  'var(--neon-purple)',
  'var(--neon-orange)',
];

const PIECES = 90;
const DURATION_MS = 7000;

interface Piece {
  left: number;
  delay: number;
  duration: number;
  drift: number;
  spin: number;
  color: string;
  width: number;
  height: number;
  round: boolean;
}

function buildPieces(): Piece[] {
  return Array.from({ length: PIECES }, () => ({
    left: Math.random() * 100,
    delay: Math.random() * 1.2,
    duration: 3 + Math.random() * 2.5,
    drift: (Math.random() - 0.5) * 40,
    spin: 360 + Math.random() * 1080,
    color: COLORS[Math.floor(Math.random() * COLORS.length)],
    width: 6 + Math.random() * 6,
    height: 10 + Math.random() * 8,
    round: Math.random() < 0.25,
  }));
}

export default function Confetti({ onDone }: { onDone?: () => void }) {
  // Las piezas se generan en el cliente (Math.random) para no romper la
  // hidratación con un render distinto en el servidor.
  const [pieces, setPieces] = useState<Piece[]>([]);

  useEffect(() => {
    setPieces(buildPieces());
    const t = setTimeout(() => onDone?.(), DURATION_MS);
    return () => clearTimeout(t);
  }, [onDone]);

  if (pieces.length === 0) return null;

  return (
    <div className="confetti-layer" aria-hidden="true">
      {pieces.map((p, i) => (
        <span
          key={i}
          className="confetti-piece"
          style={{
            left: `${p.left}%`,
            width: `${p.width}px`,
            height: p.round ? `${p.width}px` : `${p.height}px`,
            borderRadius: p.round ? '50%' : '2px',
            background: p.color,
            animationDelay: `${p.delay}s`,
            animationDuration: `${p.duration}s`,
            ['--confetti-drift' as string]: `${p.drift}vw`,
            ['--confetti-spin' as string]: `${p.spin}deg`,
          }}
        />
      ))}
    </div>
  );
}
